import repository from '@/repositories/repository'

export default baseUrl => {
    baseUrl = `${baseUrl}/regulacao`

    const headers = { responseType: "arraybuffer" }

    return {
        relatorioSolicitacao(queryParms) {
            return repository.post(`${baseUrl}/relatorio-solicitacao`, queryParms, headers)
        },
    }
}
